export default { sha: '9dad492545dd75a497ed66da09d425ee35ce28bd', buildNumber: 'undefined' }
